import server from "../../../server";
import { Document_Type } from "../../../constant/constant";
import { Document, Meta } from "../../../domains/models/document";
import { EventData } from "../../../domains/models/event";
import { FolderViewModel } from "../type/media-hub.types";
import Locale from "../../../core/locale/locale";
import dayjs from 'dayjs';
import { FindDocumentsParams } from "../../../server/document";

const defaultPageSize = 20;
const defaultPageNumber = 0;
export const maximumDeleteLimit = 20;


export async function getMedia(param: FindDocumentsParams, pageNum?: number, pageSize?: number) {
    const size = pageSize ? pageSize : defaultPageSize;
    const num = pageNum ? pageNum : defaultPageNumber;
    const response = await server.document.find(param, num, size);
    return response;
}



export async function fetchMetaFields(docType: string) {
    const res = await server.document.fetchMetaData(docType);
    return res;
}

export async function updateMetaData(docId:string,metaValues:Meta[]) {
   await server.document.updateMetaData(docId,metaValues);
}

export async function deleteDocument(documentId: string) {
    await server.document.delete(documentId);
}

export async function deleteMultiple(documentIds: string[]) {
    await server.document.deleteMultiple(documentIds);
}

export async function download(documentId: string) {
    const res = await server.document.download(documentId);
    return res;
}

export async function downloadMultiple(documentIds: string[]) {
    const res = await server.document.downloadMultiple(documentIds);
    return res;
}

export async function uploadMedia(files: File[], type: keyof typeof Document_Type) {
    const docRes = await server.document.upload(files, type);
    return docRes;
}

export async function uploadEventMedia(eventId: string, imageIds: string[]) {
    await server.event.upload(eventId, imageIds);
}


export function mediaDocumentMapper(res: Document[]) {
    return res.map((item: Document) => {
        return {
            id: item.id,
            fileName: item.fileName,
            originalFileName: item.originalFileName,
            location: item.location,
            contentType: item.contentType,
            size: item.size,
            thumbnails: item?.thumbnails,
            auditInfo: item.auditInfo,
            metaData: item.metaData
        }
    })
}


export function mapEventToFolderViewModel(res: EventData): FolderViewModel[] {
    const formatDate = (date: string | Date) =>
        dayjs(date).format(Locale.displayDateLong);

    let formattedData: FolderViewModel[] = [];

    if (res.birthdays) {
        formattedData = (res.birthdays ?? []).map(item => ({
            id: item.id,
            name: item.name,
            rawStartDate: item.startDate,
            startDate: formatDate(item.startDate),
            photoCount: item.photoCount,
            coverImage: item.coverImage ?? undefined,
            profilePhoto: item.profilePhoto,
            type: 'birthdays' as const
        }));
    }

    if (res.workAnniversaries) {
        formattedData = (res.workAnniversaries ?? []).map(item => ({
            id: item.id,
            name: item.name,
            rawStartDate: item.startDate,
            startDate: formatDate(item.startDate),
            coverImage: item.coverImage ?? undefined,
            photoCount: item.photoCount,
            type: 'workAnniversaries' as const
        }));
    }

    if (res.trainingEvents) {
        // if(res.events)
        formattedData = (res.trainingEvents ?? [])
            .map(item => ({
                id: item.id,
                name: item.name,
                rawStartDate: item.startDate,
                startDate: formatDate(item.startDate),
                endDate: formatDate(item.endDate),
                photoCount: item.photoCount,
                coverImage: item.coverImage ?? undefined,
                type: 'events' as const
            }));
    }

    if (res.events) {
        formattedData = (res.events ?? [])
            .map(item => ({
                id: item.id,
                name: item.name,
                rawStartDate: item.startDate,
                startDate: formatDate(item.startDate),
                endDate: formatDate(item.endDate),
                photoCount: item.photoCount,
                coverImage: item.coverImage ?? undefined,
                type: 'events' as const
            }));
    }


    //sort data on basis of photo count available
    const sortData = [...formattedData].sort((a, b) => {
        const startA = a.photoCount;
        const startB = b.photoCount
        if (startA > startB) {
            return -1
        } else if (startA < startB) {
            return 1;
        } else {
            return 0;
        }
    });


    return sortData;
}
